(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8047],{

/***/ 97274:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-up.f1d1d9a0.svg","height":10,"width":16});

/***/ }),

/***/ 12522:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-top-arrow.62e44c63.svg","height":20,"width":12});

/***/ }),

/***/ 57493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        addToCart: t("kf.myList.details.page.addToCart"),
        addItemsToCart: t("kf.myList.details.page.addItemsToCart"),
        moreOptions: t("kf.myList.details.page.moreOptions"),
        close: t("kf.myList.details.page.close"),
        myListPageTitle: t("kf.mylist.page.title"),
        createdDate: t("kf.myList.page.created"),
        createList: t("kf.saveToList.create.header"),
        tablTitle: t("kf.account.label.lists"),
        tablTitleMedia: t("kf.account.label.media"),
        listPageEmptyText: t("kf.myList.page.emptyTxt"),
        bestSellers: t("kf.myList.page.bestSellers"),
        sortBy: t("kf.favorite.label.sort"),
        edit: t("kf.account.label.edit"),
        deleteList: t("kf.myList.page.deletList"),
        moveItems: t("kf.myList.page.details.moveItems"),
        deleteItems: t("kf.myList.page.details.deleteItems"),
        itemPrice: t("kf.list.table.itemPrice"),
        quantity: t("kf.list.table.cartQuantity"),
        total: t("kf.list.table.total"),
        item: t("kf.list.table.item"),
        featured: t("kf.plp.label.featured"),
        listTotal: t("kf.myList.page.details.listTotal"),
        browseMoreProducts: t("kf.myList.page.details.browseMoreProducts"),
        selectAll: t("kf.list.button.selectAll"),
        created: t("kf.myList.page.details.create.label"),
        backToTop: t("kf.plp.label.backToTop"),
        editList: t("kf.myList.page.details.editList"),
        viewList: t("kf.findstore.label.viewList"),
        shoupOurBestSeller: t("kf.myList.page.ourBestSellers"),
        shoupOurBestSellerListBtn: t("kf.myList.page.ourBestSellers.listPage"),
        lessStock: t("kf.list.details.lessStock"),
        outOfStock: t("kf.list.details.outOfStock"),
        quantityModelHeader: t("kf.list.details.quantity.header"),
        quantityModelSubHeader: t("kf.list.details.quantity.subHeader"),
        addAvailableItemsToCart: t("kf.list.details.quantity.addAllToCart"),
        loadMore: t("kf.myList.page.details.loadMore"),
        availColorCTA: t("kf.myList.details.page.availColorCTA"),
        discontinued: t("kf.myList.details.page.discontinued"),
        colorAndFinish: t("kf.myList.details.page.colorAndFinish")
    };
};


/***/ }),

/***/ 75744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ handleViewDataLayer; },
/* harmony export */   "pV": function() { return /* binding */ pressKitDataLayer; },
/* harmony export */   "rk": function() { return /* binding */ getTabContentEventInfo; },
/* harmony export */   "rq": function() { return /* binding */ getPressRoomEventInfo; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y": function() { return /* binding */ handleContactDataLayer; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const getEventInfo = (pressReleaseInfo, type, linkName)=>{
    const internalLinkName = linkName || type;
    var ref;
    return JSON.stringify({
        eventAction: "press room:press releases:".concat(type),
        eventName: "press room:press releases:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(pressReleaseInfo["navTitle_s"] ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oOy)(pressReleaseInfo["navTitle_s"]) : ""),
        internalLinkZoneName: "press room:press releases:main content area",
        internalLinkURL: linkName === "download" ? "n/a" : "".concat((ref = pressReleaseInfo["url_s"]) !== null && ref !== void 0 ? ref : "#"),
        clickInternalLinks: "true"
    });
};
const getTabContentEventInfo = function(linkName, type, linkType, analyticsLabel) {
    let url = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, zone = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    let zoneName;
    switch(type){
        case "email id":
            zoneName = linkType;
            break;
        case "share":
            zoneName = "contact";
            break;
        default:
            zoneName = zone !== null && zone !== void 0 ? zone : "contacts";
    }
    let internalLinkURL;
    switch(type){
        case "contact number":
            internalLinkURL = "tel:".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeDOMString */ .TRt)(url).replace("\n", ""));
            break;
        default:
            internalLinkURL = "n/a";
    }
    return JSON.stringify({
        eventAction: "press room:".concat(analyticsLabel, ":").concat(type),
        eventName: "press room:".concat(analyticsLabel, ":").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(linkName),
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(linkType),
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":").concat(zoneName),
        internalLinkURL,
        clickInternalLinks: "true"
    });
};
const handleContactDataLayer = (analyticsLabel)=>{
    return JSON.stringify({
        eventAction: "press room:".concat(analyticsLabel, ":print"),
        eventName: "press room:".concat(analyticsLabel, ":print"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "print",
        internalLinkPosition: "press room",
        internalLinkType: "press room:print",
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":contacts"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const handleViewDataLayer = (analyticsLabel)=>{
    return JSON.stringify({
        eventAction: "press room:p".concat(analyticsLabel, ":view more"),
        eventName: "press room:p".concat(analyticsLabel, ":view more"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view more",
        internalLinkPosition: "press room",
        internalLinkType: "press room:view more",
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":contacts"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const pressKitDataLayer = (pressKitInfo)=>{
    return JSON.stringify({
        eventAction: "press room:press kits:view press kit link",
        eventName: "press room:press kits:view press kit link",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view press kit",
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(pressKitInfo["navTitle_s"] || ""),
        internalLinkZoneName: "press room:press kits:main content area",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getPressRoomEventInfo = function(page, title, type) {
    let limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", all = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    page = page.replace("-", " ");
    return JSON.stringify({
        eventAction: "".concat(title, ":").concat(page, ":").concat(type),
        eventName: "".concat(title, ":").concat(page, ":").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(limit || all),
        internalLinkPosition: "".concat(page),
        internalLinkType: "".concat(title, ":").concat(page, ":").concat(type),
        internalLinkZoneName: "".concat(title, ":").concat(page, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};


/***/ }),

/***/ 1306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21525);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _components_PressRoomLanding_v1_pressRoomAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75744);





const ProductsPerPage = (param)=>{
    let { data =[] , texts , page , onChange , totalResults , curRows =30 , pos ="top" , selectedTab  } = param;
    const getAnalyticsData = function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        limit = limit + "";
        let analyticsData = "";
        if (page === "search") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: limit,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: texts.all,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "technicalspecs") {
            if (!all) {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "favorites") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(limit),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(texts.all),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "article") {
            analyticsData = JSON.stringify({
                eventAction: "support:help and faq:article list:pagination",
                eventName: "support:help and faq:article list:pagination",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !all ? limit : texts.all,
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:pagination " + pos,
                internalLinkZoneName: "support:help and faq:article list",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (page === "literature") {
            if (!all) {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-release") {
            const type = "pagination";
            if (!all) {
                analyticsData = (0,_components_PressRoomLanding_v1_pressRoomAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .getPressRoomEventInfo */ .rq)(page, texts.title, type, limit);
            } else {
                analyticsData = (0,_components_PressRoomLanding_v1_pressRoomAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .getPressRoomEventInfo */ .rq)(page, texts.title, texts.all, type);
            }
        } else if (page === "press-kits") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "blog") {
            const pageCount = !all ? limit : "all";
            const category = selectedTab ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(selectedTab) : "";
            const linkName = "view ".concat(pageCount);
            const blogCategory = category && category === "how tos" ? "how to's" : category;
            const linkUrl = "";
            const eventInfo = {
                clickInternalLinks: "true",
                eventAction: "blog listing:".concat(blogCategory, ":main content area:pagination"),
                eventName: "blog listing:".concat(blogCategory, ":main content area:pagination"),
                eventType: "navigation",
                internalLinkName: linkName ? linkName : "pagination",
                internalLinkPosition: "blogs listing",
                internalLinkType: "blog listing:navigation",
                internalLinkZoneName: "blog listing:".concat(blogCategory, ":main content area"),
                internalLinkURL: linkUrl ? linkUrl.indexOf("http") === -1 ? window.location.origin + linkUrl : linkUrl : "n/a"
            };
            analyticsData = JSON.stringify(eventInfo);
        } else {
            const internalLinkZoneName = pos === "top" ? '"plp:sticky nav filter"' : '"plp:promo tiles"';
            if (!all) {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        }
        return analyticsData;
    };
    const checkPaginationPosition = (limit)=>{
        onChange(limit);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().productPerPageWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "products-per-page",
            children: totalResults > 30 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                role: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "disabled",
                        "aria-hidden": true,
                        children: texts.view
                    }),
                    data.map((limit, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            "aria-disabled": curRows === limit,
                            role: "button",
                            tabIndex: "0",
                            "aria-label": "".concat(texts.view, " ").concat(limit, " ").concat(texts.items),
                            className: (curRows === limit && "disabled") + " gbh-data-layer",
                            "data-gbh-data-layer": getAnalyticsData(limit),
                            onClick: ()=>checkPaginationPosition(limit),
                            children: limit
                        }, i))
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductsPerPage);


/***/ }),

/***/ 75329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_Sort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/ProductList/v2/Sort/sortAnalytics.js
const getAnalyticsData = function(item) {
    let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, { selectedtab , page  } = arguments.length > 2 ? arguments[2] : void 0, myListTitle = arguments.length > 3 ? arguments[3] : void 0;
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    let analyticsData = {
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(item.name),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "search" && selectedtab === "technical") {
        analyticsData = {
            ...analyticsData,
            eventAction: "search results:technical:main content area:sort by",
            eventName: "search results:technical:main content area:sort by",
            internalLinkPosition: "search results",
            internalLinkType: "search results:sort by",
            internalLinkZoneName: "search results:technical:main content area"
        };
    }
    switch(page){
        case "search":
            analyticsData = {
                ...analyticsData,
                eventAction: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventName: "search results:".concat(selectedtab, ":main content area:sort by"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: "search results:".concat(selectedtab, ":main content area")
            };
            break;
        case "favorites":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:".concat(myListHeading, ":").concat(selectedtab, ":sort by"),
                eventName: "my account:".concat(myListHeading, ":").concat(selectedtab, ":sort by"),
                internalLinkPosition: "my account:".concat(myListHeading, ":").concat(selectedtab),
                internalLinkType: "my account:".concat(myListHeading, ":").concat(item.name),
                internalLinkZoneName: "my account:".concat(myListHeading, ":").concat(selectedtab)
            };
            break;
        case "article":
            analyticsData = {
                ...analyticsData,
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​"
            };
            break;
        case "active-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services"
            };
            break;
        case "past-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services"
            };
            break;
        case "literature":
            analyticsData = {
                ...analyticsData,
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area"
            };
            break;
        case "press-release":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area"
            };
            break;
        case "press-kits":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area"
            };
            break;
        case "my products":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products"
            };
            break;
        default:
            analyticsData = {
                ...analyticsData,
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter"
            };
    }
    if (needJson) return analyticsData;
    return JSON.stringify(analyticsData);
};

// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
;// CONCATENATED MODULE: ./hooks/useOnClickOutside.js


/**
 *
 * @param {*} ref
 * @param {*} handler
 */ const useOnClickOutside = (ref, handler)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        if (!isSsr) {
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
        }
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler,
        isSsr
    ]);
};
/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);

// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/localization.js
var localization = __webpack_require__(57493);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./components/ProductList/v2/Sort/index.jsx










const Sort = (param)=>{
    let { texts: { sort ="" , selected ="" , sortByAria ="" , altSort ="" , sortbyExpanded ="" , sortbyClosed =""  } , data , onChange , page , selectedtab , tabIndex =0 , isSearch , selectedSort , isMyFavoriteTab =false , isMyList =false  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const sortClass = classnames_default()({
        sort: true,
        "sort--open": isOpen
    });
    const sortBtn = (0,react.useRef)(null);
    const pastServiceMenu = (0,react.useRef)(null);
    const sortByWrapper = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    hooks_useOnClickOutside(sortByWrapper, ()=>{
        isOpen && setIsOpen(false);
    });
    const btnKeyDown = (e)=>{
        switch(e.keyCode){
            case constants.KEYCODE.ENTER:
                e.preventDefault();
                !isOpen ? pastServiceMenu.current.firstElementChild.focus() : "";
                setIsOpen(!isOpen);
                break;
            case constants.KEYCODE.SPACE:
                e.preventDefault();
                !isOpen ? pastServiceMenu.current.firstElementChild.focus() : "";
                setIsOpen(!isOpen);
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        e.preventDefault();
        const ele = pastServiceMenu.current.childNodes;
        switch(e.keyCode){
            case constants.KEYCODE.ESC:
                setIsOpen(false);
                break;
            case constants.KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case constants.KEYCODE.DOWN:
                if (i < data.length - 1) ele[i + 1].focus();
                break;
            case constants.KEYCODE.SPACE:
            case constants.KEYCODE.ENTER:
                ele[i].click();
                sortBtn.current.focus();
                break;
            default:
                break;
        }
    };
    const handleDatalayer = (item, needsJson, param)=>{
        let { selectedtab , page  } = param;
        const myListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle;
        return !isMyList && getAnalyticsData(item, null, {
            selectedtab,
            page
        }, myListTitle);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: sortClass,
        ref: sortByWrapper,
        "aria-description": sort,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: sortBtn,
                className: "sort__toggle",
                tabIndex: tabIndex,
                role: "combobox",
                "aria-expanded": isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                onKeyDown: btnKeyDown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sort-by-text",
                        children: [
                            sort,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sort-options",
                        children: " ".concat(isMyFavoriteTab ? "" : ":", " ").concat(selectedSort ? selectedSort.name : "Featured")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_up/* default */.Z === null || arrow_up/* default */.Z === void 0 ? void 0 : arrow_up/* default.src */.Z.src,
                        alt: altSort,
                        className: "sort__toggle-icon",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                ref: pastServiceMenu,
                className: "sort__drop-down",
                "aria-label": isOpen ? sortbyExpanded || "Sort By Button expanded" : sortbyClosed || "Sort By Button Closed",
                children: data.map((item, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        id: "select-options-".concat(i),
                        role: "option",
                        tabIndex: "-1",
                        "aria-selected": (item === null || item === void 0 ? void 0 : item.name) === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                        className: "sort__item gbh-data-layer ".concat((item && item.name) === (selectedSort && selectedSort.name) ? "active" : ""),
                        "data-gbh-data-layer": handleDatalayer(item, null, {
                            selectedtab,
                            page
                        }),
                        onClick: ()=>{
                            onChange(item);
                            setIsOpen(false);
                        },
                        onKeyDown: (e)=>handleKeyDown(i, e),
                        children: item.name
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var v2_Sort = ((0,lib/* withOrientationChange */.Qe)(Sort));


/***/ }),

/***/ 21525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPerPageWrapper":"ProductsPerPage_productPerPageWrapper__kgU0n"};

/***/ })

}]);